
import ByteView from '../index.js'

const RFC4648 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'
const RFC4648_HEX = '0123456789ABCDEFGHIJKLMNOPQRSTUV'
const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'

const ENCODINGS = {
  base32: RFC4648,
  base32hex: RFC4648_HEX,
  base32crockford: CROCKFORD
}

function toType (input) {
  const type = typeof input
  if (type === 'object' || type === 'number') {
    const tag = Object.prototype.toString.call(
      input
    ).slice(8, -1)
    return tag === 'Number' ? 'number' : tag
  } else {
    return type
  }
}

export default class Base32 {
  #encoding
  #alphabet
  #padding

  constructor (encoding = 'base32', padding = true) {
    this.#encoding = encoding
    this.#alphabet = ENCODINGS[encoding] || RFC4648
    this.#padding = padding
  }

  get [Symbol.toStringTag] () {
    return 'Base32'
  }

  get encoding () {
    return this.#encoding
  }

  get padding () {
    return this.#padding
  }

  set padding (bool) {
    this.#padding = bool === true
  }

  byteLength (string) {
    const { length } = string
    let validLength = string.indexOf('=')
    if (validLength === -1) validLength = length

    const placeHoldersLength = validLength === length
      ? 0
      : length - validLength

    return (((length - placeHoldersLength) * 5) / 8) | 0
  }

  decode (string) {
    const { length } = string
    let bits = 0
    let value = 0
    let index = 0
    const bytes = new ByteView(this.byteLength(string))
    let i = -1

    while (++i < length) {
      if (string[i] === '=') continue
      value = (value << 5) | this.#alphabet.indexOf(string[i])
      bits += 5

      if (bits >= 8) {
        bytes[index++] = (value >>> (bits - 8)) & 0xFF
        bits -= 8
      }
    }

    return bytes
  }

  encode (byteView) {
    const type = toType(byteView)

    if (
      type !== 'Uint8Array' &&
      type !== 'ByteView' &&
      type !== 'Array' &&
      !ArrayBuffer.isView(byteView)
    ) {
      throw new Error('[Base32[encode]] did not recieve valid type')
    }

    const { length } = byteView
    let index = -1
    let bits = 0
    let value = 0
    let response = ''

    while (++index < length) {
      const byte = byteView[index]
      value = (value << 0x8) | byte
      bits += 8

      while (bits >= 5) {
        response += this.#alphabet[(value >>> (bits - 5)) & 0x1F]
        bits -= 5
      }
    }

    if (bits > 0) {
      response += this.#alphabet[(value << (5 - bits)) & 0x1F]
    }

    if (this.padding) {
      while (response.length % 8 !== 0) {
        response += '='
      }
    }

    return response
  }
}
